import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyBanner() {
  const {
    formattedTime
  } = useCountdown();
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="fixed top-0 left-0 w-full z-[9999] bg-[#F9C74F] shadow-lg" data-id="element-426">
      <div className="max-w-[1200px] mx-auto px-3 sm:px-4 py-2 flex items-center justify-between gap-2" data-id="element-427">
        {/* Timer + Social Proof */}
        <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0" data-id="element-428">
          <span className="bg-black/80 text-white font-black text-xs sm:text-sm px-2.5 py-1 rounded-md tabular-nums whitespace-nowrap shrink-0" data-id="element-429">
            ⏳ {formattedTime}
          </span>
          <span className="text-black font-bold text-[11px] sm:text-sm truncate" data-id="element-430">
            <span className="hidden sm:inline" data-id="element-431">OFERTA FLASH: </span>
            <span className="font-black" data-id="element-432">$14</span>
            <span className="hidden md:inline" data-id="element-433"> · 742 hombres en control</span>
          </span>
        </div>

        {/* Mobile Nav */}
        <nav className="flex items-center gap-1" data-id="element-434">
          <button onClick={() => scrollTo('social-proof')} className="bg-black/10 hover:bg-black/20 text-black text-[11px] sm:text-xs font-bold px-2 sm:px-3 py-1.5 rounded-md transition-all border-none cursor-pointer whitespace-nowrap min-h-[34px]" data-id="element-435">
            ⭐ Reseñas
          </button>
          <button onClick={() => scrollTo('value-stack')} className="bg-black text-[#F9C74F] text-[11px] sm:text-xs font-black px-2 sm:px-3 py-1.5 rounded-md transition-all border-none cursor-pointer whitespace-nowrap min-h-[34px] hover:bg-black/80" data-id="element-436">
            💳 Comprar
          </button>
        </nav>
      </div>
    </div>;
}